import { ChildFormDataModel } from 'zr-dynamic-form/dynamic-form-designer';

/**
 * ç§»é¤ä¸éè¦ä¿å­å­è¡¨åä¸­çæ°æ®
 * å¤æ­å¦ææ²¡æåå§æ°æ®ï¼è®¤ä¸ºæ¯æ·»å ï¼æææ°æ®é½ä¼ ç»åç«¯ï¼åç«¯æ ¹æ®å¯¹åºçå­è¡¨åï¼ä»ä¸»è¡¨ä¸­ååºææId
 * ç¶åå¤æ­æ¯å¦æå é¤çï¼æå é¤çå é¤ï¼å©ä½çç¨æ·»å åæ´æ°ç´æ¥æ§è¡
 */
export function removeUnnecessaryChildFormData(
  childrenData: ChildFormDataModel[],
  originChildrenData: ChildFormDataModel[]
): ChildFormDataModel[] {
  if (!childrenData || !originChildrenData) {
    return childrenData;
  }

  childrenData = childrenData.map((s) => {
    const originData = originChildrenData.find((o) => o.formCode === s.formCode);

    s.data = s.data.map((d) => {
      if (!d.id) {
        return d;
      }

      const originChildData = originData.data.find((o) => o.id === d.id);
      if (!originChildData) {
        return d;
      }

      // è¦æ¢ä¸ä¸ªå¯¹è±¡æ¯è¾çæ¹å¼
      const isRemove = controlsDataEqual(d.data.controlsData, originChildData.data.controlsData);

      if (isRemove) {
        // æ¸ç©ºè¦ä¼ çè¡¨åæ°æ®ï¼è¡¨ç¤ºä¸æ´æ°æ°æ®
        d.data.controlsData = undefined;
      }

      if (d.data.childrenFormData) {
        if (d.data.childrenFormData.length === 0) {
          // æ²¡æå¿è¦ä¼ è¿ä¸ªtargetIdåformCode
          d.data.childrenFormData = undefined;
        } else {
          // å¾ªç¯ç»§ç»­
          removeUnnecessaryChildFormData(d.data.childrenFormData, originChildData.data.childrenFormData);
        }
      }
      return d;
    });

    return s;
  });

  return childrenData;
}

/**
 * å¤æ­ä¸¤ä¸ªæ§ä»¶å¼æ¯å¦ç¸ç­
 *
 */
export function controlsDataEqual(
  controlsData: { [key: string]: any },
  originControlsData: { [key: string]: any }
): boolean {
  if (Object.keys(originControlsData).length !== Object.keys(controlsData).length) {
    return false;
  }

  for (const entity of Object.keys(originControlsData)) {
    if (originControlsData[entity] === undefined || controlsData[entity] === undefined) {
      return false;
    }
    for (const key in originControlsData[entity]) {
      if (key === 'Id') {
        continue;
      }
      if (JSON.stringify(controlsData[entity][key]) !== JSON.stringify(originControlsData[entity][key])) {
        return false;
      }
    }
  }

  return true;
}

/**
 * ç§»é¤ä¸å¿è¦çå±æ§
 *
 */
export function removeUnnecessaryProperty(childrenData: ChildFormDataModel[]) {
  if (!childrenData) {
    return;
  }
  childrenData.forEach((s) => {
    if (s.data) {
      s.data.forEach((d) => {
        // æ²¡æå¿è¦ä¼ è¿ä¸ªtargetIdåformCodeï¼åå°ä½ç§¯
        // æªæ¥å¦æåç«¯æ°æ®æ ¼å¼è°æ´ï¼è¿ä¸ªå°±å¯ä»¥å»æ
        d.targetId = undefined;
        d.formCode = undefined;
        if (d.data.childrenFormData) {
          if (d.data.childrenFormData.length === 0) {
            d.data.childrenFormData = undefined;
          } else {
            removeUnnecessaryProperty(d.data.childrenFormData);
          }
        }
      });
    }
  });
}
